import { OpportunityAndRiskCard } from '@/components/molecules/cards/opportunityAndRisk';
import { RadarChart } from '@/components/molecules/charts/radar';
import { DataItem } from '@/utils/functions/chart';
import { StyledCharts } from './styles';

interface SeriesProps {
  dataKey: string;
  name: string;
  fillColor: string;
  strokeColor: string;
}

interface ComparativeChartsProps {
  municipalityName: string;
  series: SeriesProps[];
  opportunityChartData: DataItem[];
  riskChartData: DataItem[];
}

export const Charts = ({
  municipalityName,
  opportunityChartData,
  riskChartData,
  series,
}: ComparativeChartsProps) => {
  return (
    <StyledCharts>
      <OpportunityAndRiskCard variant="opportunity" padding={1}>
        <RadarChart
          municipalityName={municipalityName}
          key={`opportunity-${municipalityName}-${series.map((s) => s.name).join('-')}`}
          data={opportunityChartData}
          series={series}
        />
      </OpportunityAndRiskCard>

      <OpportunityAndRiskCard variant="risk" padding={1}>
        <RadarChart
          municipalityName={municipalityName}
          key={`risk-${municipalityName}-${series.map((s) => s.name).join('-')}`}
          data={riskChartData}
          series={series}
        />
      </OpportunityAndRiskCard>
    </StyledCharts>
  );
};
